import { createIsomorphicFn } from '@tanstack/react-start';
import { getClientContext } from './client';
import { getServerContext } from './server';

export const getAppContext = createIsomorphicFn()
	.server(() => getServerContext())
	.client(() => getClientContext());
